<template>
  <b-overlay :show="showOverlay">

    <div v-if="pageData && pageData.value">
      <b-card>
        <language-picker
            @getLanguage="setLanguage"
        ></language-picker>
      </b-card>
      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 1</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="firstCardText"
            >
              <b-form-input
                  id="firstCardText"
                  v-model="pageData.value.firstCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="firstCardIcon"
            >
              <b-form-textarea
                  id="firstCardIcon"
                  v-model="pageData.value.firstCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="firstCardDescription"
            >
              <b-form-textarea
                  id="firstCardIcon"
                  v-model="pageData.value.firstCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 2</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="secondCardText"
            >
              <b-form-input
                  id="secondCardText"
                  v-model="pageData.value.secondCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="secondCardIcon"
            >
              <b-form-textarea
                  id="secondCardIcon"
                  v-model="pageData.value.secondCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="secondCardDescription"
            >
              <b-form-textarea
                  id="secondCardDescription"
                  v-model="pageData.value.secondCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 3</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="thirdCardText"
            >
              <b-form-input
                  id="thirdCardText"
                  v-model="pageData.value.thirdCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="thirdCardIcon"
            >
              <b-form-textarea
                  id="thirdCardIcon"
                  v-model="pageData.value.thirdCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="thirdCardDescription"
            >
              <b-form-textarea
                  id="thirdCardDescription"
                  v-model="pageData.value.thirdCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 4</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="fourthCardText"
            >
              <b-form-input
                  id="fourthCardText"
                  v-model="pageData.value.fourthCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="fourthCardIcon"
            >
              <b-form-textarea
                  id="fourthCardIcon"
                  v-model="pageData.value.fourthCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="fourthCardDescription"
            >
              <b-form-textarea
                  id="fourthCardDescription"
                  v-model="pageData.value.fourthCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 5</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="fifthCardText"
            >
              <b-form-input
                  id="fifthCardText"
                  v-model="pageData.value.fifthCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="fifthCardIcon"
            >
              <b-form-textarea
                  id="fifthCardIcon"
                  v-model="pageData.value.fifthCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="fifthCardDescription"
            >
              <b-form-textarea
                  id="fifthCardDescription"
                  v-model="pageData.value.fifthCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Card 6</h1>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Title"
                label-for="sixthCardText"
            >
              <b-form-input
                  id="sixthCardText"
                  v-model="pageData.value.sixthCardText"
                  dir="auto"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Icon"
                label-for="sixthCardIcon"
            >
              <b-form-textarea
                  id="sixthCardIcon"
                  v-model="pageData.value.sixthCardIcon"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
                class="mb-2"
                label="Description"
                label-for="sixthCardDescription"
            >
              <b-form-textarea
                  id="sixthCardDescription"
                  v-model="pageData.value.sixthCardDescription"
                  dir="auto"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="my-2" cols="12">
            <b-button class="btn" type="button" variant="primary" @click="updateFooter">Submit changes</b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCarousel,
  BCarouselSlide,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {DynamicPagesGetBy, DynamicPagesGetByType, UpdateDynamicPages} from "@/libs/Api/DynamicPages";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";

export default {
  name: "Categories",
  title: "Categories",
  data() {
    return {
      showOverlay: false,
      languageList:[],
      rawHTML: '',
      languageId:1,
      pageData: null,
    }
  },
  watch: {
    languageId: {
      handler(val) {
        this.getPageData();
      },
    },
  },
  async created() {
    await this.getPageData();
  },
  methods: {
    async getPageData() {
      let _this = this;
      _this.showOverlay = true;

      let dynamicPagesGetBy = new DynamicPagesGetByType(_this);
      dynamicPagesGetBy.setParams({
        type: 5,
        LanguageId:_this.languageId
      })
      await dynamicPagesGetBy.fetch(function (content) {
        _this.showOverlay = false;
        _this.pageData = content.data;
        _this.pageData.value = JSON.parse(_this.pageData.value);
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async updateFooter() {
      let _this = this;
      _this.showOverlay = true;

      let updateDynamicPages = new UpdateDynamicPages(_this);
      // _this.pageData.value['telegram'] = '';
      _this.pageData.value = JSON.stringify(_this.pageData.value);
      updateDynamicPages.setParams(_this.pageData);
      await updateDynamicPages.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getPageData();
      }, function (error) {
        console.log(error);
        _this.showOverlay = false;
      })
    },
    setLanguage(language) {
      this.languageId = language.languageId;
    },
    setEditorContent(content) {
      this.pageData.value.customFooter = content;
    },
    setEditorContentMobile(content) {
      this.pageData.value.customFooterMobile = content;
    },
  },
  components: {
    LanguagePicker,
    AddEditDeleteButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BFormFile,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BCarousel,
    BCarouselSlide,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BOverlay,
    BModal,
    BFormSelect,
    vSelect,
    BFormTextarea,
  },
}
</script>

<style scoped>

</style>
